import { Image, Space } from "antd";
import SummaryWrapper from "../SummaryWrapper";
import React from "react";
import {
  getLabelTagsWithDescription,
  getLabelTagsWithDynamicInputs,
} from "../constructTextFromValues";
import { specialCareOptions } from "../../Options/functionalAsessmentOptions";
import SpecialCare from "../../../../assets/images/nurseIcons/specialcare.svg";
import { checkEmpty } from "../../../../helpers/utility";

const NurseSpecialCareRequirementSummary = ({ formData }) => {
  const constructNurseSpecialCareSummaryItems = () => {
    const nurseSpecialCareSummaryItems = [];
    const special_care = formData?.special_care || {};

    if (checkEmpty(special_care)) {
      nurseSpecialCareSummaryItems.push({
        key: "1",
        label: "Area(s)",
        children: (
          <>
            {getLabelTagsWithDescription(specialCareOptions, special_care)}
            {getLabelTagsWithDynamicInputs(
              special_care?.special_requirement_others
            )}
          </>
        ),
      });
    }
    return nurseSpecialCareSummaryItems;
  };
  const nurseSpecialCareSummaryItems = constructNurseSpecialCareSummaryItems();
  return (
    <>
      {nurseSpecialCareSummaryItems.length !== 0 && (
        <SummaryWrapper
          collapseAllOnMobile
          items={nurseSpecialCareSummaryItems}
          title={
            <span style={{ fontWeight: "500", marginLeft: ".2rem" }}>
              <Space>
                <Image src={SpecialCare} preview={false} />
                <span>Area of Special Care Requirement</span>{" "}
              </Space>
            </span>
          }
        />
      )}
    </>
  );
};

export default NurseSpecialCareRequirementSummary;
